import { makeStyles } from 'tss-react/mui';
export var welcomeWrapperStyle = makeStyles()(function (theme) {
    var _a, _b, _c, _d;
    var _e, _f;
    return ({
        welcomeContainer: (_a = {
                // height: 180,
                width: '100%',
                minHeight: 180,
                borderRadius: 10,
                display: 'flex',
                position: 'relative',
                alignItems: 'center',
                backgroundColor: (_f = (_e = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _e === void 0 ? void 0 : _e.customColor) === null || _f === void 0 ? void 0 : _f.primaryDark,
                marginBottom: 15,
                marginTop: 50
            },
            _a[theme.breakpoints.down('sm')] = {
                flexDirection: 'column',
                alignItems: 'flex-start',
                padding: 16,
            },
            _a),
        welcomeImage: (_b = {
                position: 'absolute',
                bottom: 0,
                height: 220
            },
            _b[theme.breakpoints.down('sm')] = {
                position: 'relative',
                height: 140,
            },
            _b),
        welcomeImageContainer: (_c = {
                width: 350,
                marginLeft: 30
            },
            _c[theme.breakpoints.down('sm')] = {
                width: '100%',
                marginLeft: 0,
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 12,
            },
            _c),
        welcomeText: (_d = {
                color: theme.palette.customColor.white
            },
            _d[theme.breakpoints.down('sm')] = {
                width: '100%',
                textAlign: 'center',
                zIndex: 1,
            },
            _d),
    });
});
